import StaticLanguagePage from '../StaticLanguagePage';
import frenchPageData from './frenchPageData';

export default function FrenchStaticPage() {
  return <StaticLanguagePage language={frenchPageData} />;
}
